import React from 'react';

interface CallToActionSectionProps {
  title: string;
  subtitle: string;
  themeColor?: 'red' | 'blue' | 'purple' | 'yellow';
}

export const CallToActionSection: React.FC<CallToActionSectionProps> = ({
  title,
  subtitle,
  themeColor = 'red'
}) => {
  const themeClasses = {
    red: 'from-red-600 to-red-800',
    blue: 'from-blue-600 to-blue-800',
    purple: 'from-purple-600 to-purple-800',
    yellow: 'from-yellow-500 to-orange-600'
  };

  return (
    <section className={`py-20 bg-gradient-to-r ${themeClasses[themeColor]} text-white`}>
      <div className="container mx-auto px-4">
        <div className="text-center">
          <h2 className="text-4xl font-bold mb-6">{title}</h2>
          <p className="text-xl text-opacity-90 mb-8 max-w-3xl mx-auto">
            {subtitle}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12 max-w-xl mx-auto">
            <a 
              href="tel:+918714014140"
              className="inline-flex items-center justify-center px-6 py-3 bg-white text-gray-900 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-fill mr-3"></i>
              Call Now: +91 8714014140
            </a>
            <a 
              href="https://wa.me/918714014140"
              className="inline-flex items-center justify-center px-6 py-3 bg-white/10 hover:bg-white/20 border-2 border-white/30 font-semibold rounded-lg transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-3"></i>
              WhatsApp for Quick Support
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Visit Us</h3>
              <p className="text-opacity-90 text-sm">
                Device Doctor, Vyttila Jn, Kochi, Kerala
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Working Hours</h3>
              <p className="text-opacity-90 text-sm">
                Mon–Sat: 10AM–7PM | Sun: 11AM–4PM
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-truck-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">All-Kerala Courier</h3>
              <p className="text-opacity-90 text-sm">
                Send your phone safely from anywhere in Kerala
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};